export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6242.a9ba975b.jpg";